import {
	Col,
	Row,
	Button,
	MultipleRadio,
	ELanguage
} from '@microfrontends/react-components'
import React, {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState
} from 'react'
import AppContext from '../../../../context/AppContext'
import { ICareerPathByIndustry } from '../types'

interface IProps {
	industries: ICareerPathByIndustry[]
}

const BASE_URL = process.env.VNW_BASE_URL
const CAREER_PATH_STORE_KEY = 'selectedCareerPath'

const CareerSearch: React.FC<IProps> = ({ industries }) => {
	const { languageCode = ELanguage.VI, breakpoint } = useContext(AppContext)
	const [industrySelected, setIndustry] = useState<{
		industryId: number
		levelAlias: string
	} | null>(null)
	const [defaultCareer, setDefaultCareer] = useState(0)

	const baseUrl = `${BASE_URL}${
		languageCode === ELanguage.VI ? '/lo-trinh-su-nghiep' : '/career-path'
	}`

	const addIdToIndustries = useMemo(() => {
		return industries.map((industry) => ({
			...industry,
			id: industry.industryId,
			name: industry.industryName
		}))
	}, [industries])

	const handleSelectIndustry = useCallback(({ value }: { value: any }) => {
		setIndustry(value)
		localStorage.setItem(
			CAREER_PATH_STORE_KEY,
			JSON.stringify(value.industryId)
		)
	}, [])

	useEffect(() => {
		const storeValue =
			parseInt(localStorage.getItem(CAREER_PATH_STORE_KEY) || '') || 1

		setDefaultCareer(storeValue)
		setIndustry(
			industries.find((industry) => industry.industryId === storeValue) ||
				null
		)
	}, [industries])
	return (
		<Row gutter={[0, 12]}>
			<Col xs={18} sm={19}>
				<MultipleRadio
					key={defaultCareer}
					options={addIdToIndustries}
					name='CareerPath'
					value={defaultCareer}
					dropdown={{
						maxHeight: '200px',
						isSearchable: true,
						searchBoxPlaceholder: 'Tìm kiếm'
					}}
					onChange={handleSelectIndustry}
					placeholder='Chọn lộ trình sự nghiệp ngành nghề'
					fieldValue={['industryId', 'levelAlias']}
					isMobile={breakpoint === 'mobile'}
				/>
			</Col>
			<Col xs={6} sm={5}>
				<a
					href={
						industrySelected
							? baseUrl +
							  `/${industrySelected?.levelAlias}/${industrySelected?.industryId}`
							: undefined
					}
				>
					<Button style={{ width: '100%' }} type='primary'>
						Tra cứu
					</Button>
				</a>
			</Col>
		</Row>
	)
}

export default CareerSearch
